export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '最新最全的娱乐圈八卦资讯，明星恋情、绯闻爆料、圈内秘闻，一站式吃瓜平台。',
    icon: 'ri-chat-smile-2-line',
    articleCount: 28,
  },
  {
    slug: 'mingxing-dongtai',
    name: '明星动态',
    description: '明星行程、新作品发布、综艺录制、商业活动等第一手明星动态跟踪报道。',
    icon: 'ri-star-line',
    articleCount: 24,
  },
  {
    slug: 'yingshi-zongyi',
    name: '影视综艺',
    description: '热门影视剧推荐、综艺节目点评、票房数据、新剧开播信息汇总。',
    icon: 'ri-film-line',
    articleCount: 20,
  },
  {
    slug: 'shehui-redian',
    name: '社会热点',
    description: '社会热点事件深度追踪，网络热门话题讨论，带你看尽世间百态。',
    icon: 'ri-fire-line',
    articleCount: 22,
  },
  {
    slug: 'qiwen-qushi',
    name: '奇闻趣事',
    description: '世界之大无奇不有，收集天下奇闻异事、幽默趣图、搞笑段子，让你乐在其中。',
    icon: 'ri-lightbulb-flash-line',
    articleCount: 18,
  },
  {
    slug: 'shuma-keji',
    name: '数码科技',
    description: '热门数码产品评测、科技圈最新动态、互联网大事件追踪报道。',
    icon: 'ri-smartphone-line',
    articleCount: 16,
  },
];